/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Bc_SyncInputs */

const en_col_bc_sync = /** @type {(inputs: Col_Bc_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central`)
};

/**
* | output |
* | --- |
* | "Business Central" |
*
* @param {Col_Bc_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_bc_sync = /** @type {((inputs?: Col_Bc_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Bc_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_bc_sync(inputs)
});